import promotionCodesRepository from '@/repositories/PromotionCodesRepository'
import { CHANGE_PAYMENT_METHOD } from '@/constants/paymentTypes'
import i18nMixin from '@/mixins/i18n.mixin'

const I18N_FILE = 'payments'

export default {
    data () {
        return {
            promotionCode: null,
            showPromotionCodeQuestion: true,
            discountApplied: null,
            termsAccepted: false,
            showEPrescriptionAvailableDialog: false,
            cvvInputType: 'text',
            creditCardData: {
                holderName: null,
                cardNumber: null,
                sanitizedCardNumber: null,
                month: null,
                year: null,
                cvv: null
            },
            CHANGE_PAYMENT_METHOD
        }
    },
    mixins: [i18nMixin(I18N_FILE)],
    methods: {
        closeModalAndReload () {
            this.$emit('loadAppointments')
            this.$emit('closePaymentModal')
        },
        checkPromotionCode () {
            // TODO: Not finished. Fill in when necessary comparing with 'checkPromotionCode' in paytpv-template.js
            if (!this.promotionCode) {
                this.$store.dispatch('showInfoAlert', this.$t('payments.mustInsertCode'))
                return
            }
            promotionCodesRepository.getCodeDiscount({promotionCode: this.promotionCode, appointmentId: this.appointmentId}).then((result) => {
                let data = result.data.data
                if (!data) {
                    this.$store.dispatch('showDangerAlert', this.$t('payments.invalidCode'))
                } else {
                    let discount = data.isFixedPriceDiscount ? Math.round((data.discount / this.price) * 100) : data.discount
                    this.discountApplied = discount > 100 ? 100 : discount
                    this.$store.dispatch('showInfoAlert', this.$t('payments.appliedDiscount', {discount: this.discountApplied}))
                    if (this.freeService) {
                        this.hidePaymentSelector = true
                        this.showBizumDirect = false
                        this.paymentMethodSelected = null
                    } else {
                        this.initForm()
                    }
                }
            })
        },
        applyFullDiscount () {
            promotionCodesRepository.applyFullDiscount(this.appointmentId, this.promotionCode).then((result) => {
                let data = result.data.data
                if (!data) {
                    this.$store.dispatch('showDangerAlert', this.$t('defaultErrorMessage'))
                } else {
                    this.closeModalAndReload()
                }
            })
        },
        cvvChange () {
            this.cvvInputType = this.creditCardData.cvv ? 'password' : 'text'
        }
    },
    watch: {
        'creditCardData.cardNumber' () {
            this.creditCardData.cardNumber = this.creditCardData.cardNumber ? this.creditCardData.cardNumber.replace(/ /gi, '').match(/.{1,4}/g).join(' ') : null
            this.creditCardData.sanitizedCardNumber = this.creditCardData.cardNumber.trim().replace(/\s/g, '')
        }
    }
}


// WEBPACK FOOTER //
// ./src/mixins/payments.mixin.js